import React from "react";
import LegalPageRenderer from "../components/LegalPageRenderer";

const PrivacyPolicy = () => (
  <LegalPageRenderer slug="privacy-policy" testId="privacy-policy-page" />
);

export default PrivacyPolicy;
